export default __webpack_public_path__ + "static/media/info.944f0cb6.svg";